import Vue from "vue";
import Router, { NavigationGuard } from "vue-router";
import Home from '@/views/Home.vue';
import Preparation from '@/views/Preparation.vue';
import Alert from '@/views/Alert.vue';
import History from '@/views/History.vue';
import ProductManagement from '@/views/ProductManagement.vue';
import Store from '@/views/Store.vue';
import Stores from '@/views/Stores.vue';
import Users from '@/views/Users.vue';
import Closures from '@/views/Closures.vue';
import CollectionSlots from '@/views/CollectionSlots.vue';
import DropOffs from '@/views/DropOffs.vue';
import authentication from "./configuration/authentication";
import { PageName } from "./configuration/pages";
import MassImport from "@/views/MassImport.vue";
import SmartCollabError from "./views/SmartCollabError.vue";

Vue.use(Router);

const checkAccessRights: NavigationGuard<Vue> = (to, from, next) => {
    if (authentication.canAccess(to.name as PageName)) {
        next();
        return;
    }
    authentication.logout();
    return;
}

const checkFeatureProductManagementIsEnabledAndCheckAccessRights: NavigationGuard<Vue> = (to, from, next) => {
    if(!((window as any).config.isProductManagementFeatureEnabled)) {
        console.warn('Product Management Feature is not enabled. Redirecting to the homepage...')
        next({ name: PageName.ORDERS });
        return;
    }

    checkAccessRights(to, from, next);
}

const checkAccessRightsWithStore: NavigationGuard<Vue> = (to, from, next) => {
    if (isStoreSelected()) {
        checkAccessRights(to, from, next);
        return;
    }

    if (authentication.isCentralAdmin()) {
        next({name: PageName.STORE});
        return;
    }

    authentication.logout();
}

export default new Router({
    mode: "history", // Do not mistake with the history page
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/orders",
            name: PageName.ORDERS,
            component: Home,
            beforeEnter: checkAccessRightsWithStore
        },
        {
            path: "/preparation",
            name: PageName.PREPARATION,
            component: Preparation,
            beforeEnter: checkAccessRightsWithStore
        },
        {
            path: "/store",
            name: PageName.STORE,
            component: Store,
            beforeEnter: checkAccessRights
        },
        {
            path: "/stores",
            name: PageName.STORES,
            component: Stores,
            beforeEnter: checkAccessRightsWithStore
        },
        {
            path: "/alert",
            name: PageName.ALERT,
            component: Alert,
            beforeEnter: checkAccessRightsWithStore
        },
        {
            path: "/history",
            name: PageName.HISTORY,
            component: History,
            beforeEnter: checkAccessRightsWithStore
        },
        {
            path: "/closures",
            name: PageName.CLOSURES,
            component: Closures,
            beforeEnter: checkAccessRightsWithStore
        },
        {
            path: "/collection-slots",
            name: PageName.COLLECTION_SLOTS,
            component: CollectionSlots,
            beforeEnter: checkAccessRightsWithStore
        },
        {
            path: "/drop-offs",
            name: PageName.DROP_OFFS,
            component: DropOffs,
            beforeEnter: checkAccessRightsWithStore
        },
        {
            path: "/users",
            name: PageName.USERS,
            component: Users,
            beforeEnter: checkAccessRightsWithStore
        },
        {
            path: "/products",
            name: PageName.PRODUCTS,
            component: ProductManagement,
            beforeEnter: checkFeatureProductManagementIsEnabledAndCheckAccessRights
        },
        {
            path: "/mass-import",
            name: PageName.MASS_IMPORT,
            component: MassImport,
            beforeEnter: checkAccessRightsWithStore
        },
        {
            path: "/smart-collab-error",
            name: PageName.SMART_COLLAB_ERROR,
            component: SmartCollabError
        },
        {
            path: "/:pathMatch(.*)*",
            beforeEnter: (to, from, next) => {
                const defaultPage = authentication.isDriveUser() ? PageName.COLLECTION_SLOTS : PageName.ORDERS;
                next({ name: defaultPage });
            }
        }
    ]
});

export function isStoreSelected(): boolean {
    return sessionStorage.getItem("storeId") != null;
}
